var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agreements"},[_c('iframe',{staticStyle:{"width":"100%","height":"99%"},attrs:{"src":_vm.url + '/users/agreements/license',"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }